"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _queryString = require("@wtdc/query-string");

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @Author: Paco
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @Date: 2018-11-23 17:39:29
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @LastEditTIme: Paco
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @Description:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var RouterControl = function (_React$PureComponent) {
  _inherits(RouterControl, _React$PureComponent);

  function RouterControl(props) {
    _classCallCheck(this, RouterControl);

    var _this = _possibleConstructorReturn(this, (RouterControl.__proto__ || Object.getPrototypeOf(RouterControl)).call(this, props));

    _this.showChildren = function () {
      _this.setState({
        shouldEnter: true
      });
    };

    var onEnter = _this.props.onEnter;

    _this.delayEnter = typeof onEnter == "function" && onEnter.length === 3; //判断是否需要添加回掉进入界面
    _this.state = {
      shouldEnter: !_this.delayEnter
    };
    return _this;
  }

  _createClass(RouterControl, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var onEnter = this.props.onEnter;

      if (typeof onEnter == "function") {
        var _props = this.props,
            location = _props.location,
            match = _props.match,
            history = _props.history;

        var nextState = {
          location: location,
          match: match,
          query: _queryString2.default.parse(location.search)
        };
        onEnter(nextState, history, this.showChildren);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.delayEnter = null;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var shouldEnter = this.state.shouldEnter;

      return shouldEnter && children;
    }
  }]);

  return RouterControl;
}(_react2.default.PureComponent);

exports.default = RouterControl;